import { buildStandardizedStrategyPreview } from "@/lib/strategy/preview-payoff";
import { getRegistryEntry } from "@/lib/strategy/registry";
import type { StrategyLayerKind } from "@/types/strategy";

export function generalTemplateParams(
  kind: StrategyLayerKind,
  spot: number,
  strikeStep: number,
) {
  const params = getRegistryEntry(kind).defaultParams(spot, strikeStep);
  // The general library offers a long straddle; flagship keeps its own default.
  return kind === "straddle" ? { ...params, side: 1 } : params;
}

export function buildGeneralTemplatePreview(kind: StrategyLayerKind) {
  const spot = 100,
    strikeStep = 1;
  const params = generalTemplateParams(kind, spot, strikeStep);
  const legs = getRegistryEntry(kind).toLegs(spot, params, strikeStep);
  // Include every strike and room beyond the wings, not just the center plateau.
  const range = Math.max(
    25,
    ...legs.map((leg) => Math.abs(leg.strike - spot) * 1.5),
  );
  return buildStandardizedStrategyPreview({
    kind,
    params,
    spot,
    strikeStep,
    range,
    steps: 120,
  });
}
